import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { PackageIcon, ShieldCheckIcon } from '@phosphor-icons/react'

import {
  Alert,
  Button,
  ButtonWithSpinner,
  Card,
  CardTitle,
  shipmentStatuses,
  Text,
  TextArea,
} from '@reveni-io/reveni-ui'
import { Divider } from '@reveni-io/reveni-ui'

import PackagingSelector from '@/common/components/PackagingSelector/PackagingSelector'
import ValidationSummary from '@/common/components/ValidationSummary/ValidationSummary'
import routes from '@/Router/routes.constants'

import DiscardedItemsActions from './DiscardedItemsActions/DiscardedItemsActions'
import * as Styles from './styles'

const SummaryCard = ({
  lineItems,
  parcelId,
  notes,
  handleChangeNotes,
  isParcelEnableToPrepare,
  withCustoms,
  prepareParcel,
  preparingParcel,
  carrierServices,
  carrierServiceForNewShipment,
  setCarrierServiceForNewShipment,
  discardAction,
  setDiscardAction,
  locationForNewShipment,
  setLocationForNewShipment,
  senderLocation,
  locations,
  parcelStatus,
  amendItems,
  amendingItems,
  hasSomeItemsToAmend,
  packaging,
  selectedPackaging,
  onChangeSelectedPackaging,
}) => {
  const { t } = useTranslation()
  const navigation = useNavigate()

  const onCancel = () => {
    navigation(routes.parcelDetailPage.replace(':id', parcelId))
  }

  return (
    <Card showBorder={false}>
      <CardTitle>{t('Resumen')}</CardTitle>
      <Styles.MainContainer>
        <ValidationSummary lineItems={lineItems} />
        <Divider />
        <DiscardedItemsActions
          lineItems={lineItems}
          deliveryMethods={carrierServices}
          carrierServices={carrierServices}
          carrierServiceForNewShipment={carrierServiceForNewShipment}
          setCarrierServiceForNewShipment={setCarrierServiceForNewShipment}
          discardAction={discardAction}
          setDiscardAction={setDiscardAction}
          locationForNewShipment={locationForNewShipment}
          setLocationForNewShipment={setLocationForNewShipment}
          senderLocation={senderLocation}
          locations={locations}
        />
        <Text type="titleS">{t('Embalaje')}</Text>
        <PackagingSelector packaging={packaging} value={selectedPackaging} onChange={onChangeSelectedPackaging} />
        <Text type="titleS">{t('Notas')}</Text>
        <TextArea maxLength={100} showCounter onChange={handleChangeNotes} value={notes} />
        <Divider />
        <Styles.DocumentsContainer>
          <Text type="titleS">{t('Documentos')}</Text>
          <Text type="bodyMRegular">{t('Al continuar se generarán los siguientes documentos')}:</Text>
          <Styles.DocumentLinesContainer>
            <Styles.DocumentLine>
              <PackageIcon weight="thin" size={24} />
              <Text type="bodyMRegular">{t('1 etiqueta de envío')}</Text>
            </Styles.DocumentLine>
            {withCustoms && (
              <Styles.DocumentLine>
                <ShieldCheckIcon weight="thin" size={24} />
                <Text type="bodyMRegular">{t('1 declaración de aduanas')}</Text>
              </Styles.DocumentLine>
            )}
          </Styles.DocumentLinesContainer>
        </Styles.DocumentsContainer>
        {parcelStatus === shipmentStatuses.ready && (
          <Alert type="warning">
            {t(
              'Al editar el estado de empaquetado se creará una nueva etiqueta de envío (y la documentación asociada) que sustituirá a la generada anteriormente.'
            )}
          </Alert>
        )}
        <Styles.ActionsContainer>
          {parcelStatus !== shipmentStatuses.ready ? (
            <ButtonWithSpinner
              disabled={!isParcelEnableToPrepare || preparingParcel}
              fullWidth
              defaultLabel={t('Continuar')}
              loadingLabel={t('Continuar')}
              onClick={prepareParcel}
            />
          ) : (
            <ButtonWithSpinner
              disabled={!isParcelEnableToPrepare || !hasSomeItemsToAmend || amendingItems}
              fullWidth
              defaultLabel={t('Continuar')}
              loadingLabel={t('Continuar')}
              onClick={amendItems}
            />
          )}
          <Button fullWidth variant="outlined" onClick={onCancel}>
            {t('Cancelar')}
          </Button>
        </Styles.ActionsContainer>
      </Styles.MainContainer>
    </Card>
  )
}

export default SummaryCard
